import { t } from "@lingui/macro";
import { HouseSimple, Lock, SidebarSimple } from "@phosphor-icons/react";
import { Button, Tooltip } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useEffect, useState } from "react";
import { Link } from "react-router";

import { ThemeSwitch } from "@/client/components/theme-switch";
import { useBuilderStore } from "@/client/stores/builder";
import { useResumeStore } from "@/client/stores/resume";

export const BuilderHeader = () => {
  const title = useResumeStore((state) => state.resume.title);
  const locked = useResumeStore((state) => state.resume.locked);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => {
      window.removeEventListener("resize", checkScreen);
    };
  }, []);

  const onToggle = (side: "left" | "right") => {
    toggle(side);
  };

  return (
    <header
      style={{
        left: isMobile ? "0" : `${leftPanelSize}%`,
        right: isMobile ? "0" : `${rightPanelSize}%`,
      }}
      className={cn(
        "z-[60] mx-auto mt-1 h-16 border-b border-primary/50",
        "lg:absolute lg:inset-x-0 lg:top-0 lg:z-20 lg:max-w-[675px] lg:rounded-full lg:border",
        !isDragging && "transition-[left,right]",
        "bg-secondary-accent/50 backdrop-blur",
      )}
      role="banner"
    >
      <div className="flex h-full items-center justify-between px-4">
        <Button
          size="icon"
          variant="ghost"
          className="flex lg:hidden"
          aria-label={t`Toggle left panel`}
          onClick={() => {
            onToggle("left");
          }}
        >
          <SidebarSimple aria-hidden="true" />
        </Button>

        <div className="flex items-center justify-center gap-x-1 lg:mx-auto">
          <Button asChild size="icon" variant="ghost">
            <Link to="/dashboard/resumes" aria-label={t`Go back to dashboard`}>
              <HouseSimple aria-hidden="true" />
            </Link>
          </Button>

          <span className="mr-2 text-xs opacity-40" aria-hidden="true">
            /
          </span>

          <h1 className="max-w-[300px] truncate text-base font-medium" title={title}>
            {title}
          </h1>

          {locked && (
            <Tooltip content={t`This resume is locked, please unlock to make further changes.`}>
              <Lock size={14} className="ml-2 opacity-75" aria-hidden="true" />
            </Tooltip>
          )}
        </div>

        <ThemeSwitch />
      </div>
    </header>
  );
};
